import { addUndirectedEdge } from "utils/math/geometry/addUndirectedEdge";
import { CreateLShapedConnection } from "./types";

/**
 * Adds an L-shaped connection (Node -> Corner -> Projection) to the graph.
 * Used for connecting Sources/Destinations to the tray.
 */
export const createLShapedConnection: CreateLShapedConnection = ({
  graph,
  nodes,
  startPoint,
  startPointId,
  projectionPoint,
  projectionNodeId,
}) => {
  const cornerId = `${startPointId}_CORNER`;

  // 1. Register Coordinates
  nodes[startPointId] = startPoint;
  nodes[cornerId] = { x: startPoint.x, y: projectionPoint.y }; // Corner is (start.x, proj.y)

  // 2. Calculate Weights (Manhattan)
  const distToCorner = Math.abs(startPoint.y - projectionPoint.y);
  const distCornerToProj = Math.abs(startPoint.x - projectionPoint.x);

  // 3. Build Edges (Start -> Corner -> Projection)
  addUndirectedEdge({
    graph,
    nodeA: startPointId,
    nodeB: cornerId,
    weight: distToCorner,
  });

  addUndirectedEdge({
    graph,
    nodeA: cornerId,
    nodeB: projectionNodeId,
    weight: distCornerToProj,
  });
};
